import { Factura } from "./types";

/** Códigos SII de no cedibilidad — facturas con estos códigos NO son cotizables. */
export const NC_SII_NO_CEDIBLES: ReadonlyArray<number> = [1, 2, -10, 20, 21, 24];

/**
 * Determina si una factura es cotizable.
 *
 * Reglas (preservadas exactas del original BeforeFacture.vue:isCotizable):
 * - Si la factura ya está cedida a RedCapital (cedido_redcapital == 1), NO es cotizable.
 * - Si está cedida a un tercero (cedido == 1 && cedido_redcapital == 0), SÍ es cotizable.
 * - Si no está cedida, es cotizable solo si su nc_sii está en la lista de códigos no cedibles.
 *
 * Esa última regla es contraintuitiva (la variable se llama "esCotizable" y devuelve
 * `includes(no-cedibles)`) pero replica el comportamiento del componente original.
 * Refactorizar la semántica del nombre queda fuera de scope de este commit.
 */
export function isCotizable(
	factura: Factura,
	codigosNoCedibles: ReadonlyArray<number> = NC_SII_NO_CEDIBLES
): boolean {
	if (factura.cedido == 1) {
		return factura.cedido_redcapital == 0;
	}
	return codigosNoCedibles.includes(Number(factura.nc_sii));
}

/** Filtros del v-radio del paso 1. */
export type FilterCesion = "total" | "no_cedidas" | "cedidas_rc" | "cedidas_3ros" | null | undefined;

/**
 * Filtra facturas por estado de cesión + buscador (folio o razón social).
 * Comportamiento idéntico a BeforeFacture.vue:filtrarDatos.
 */
export function filtrarDatos(
	datos: Factura[],
	filterCesion: FilterCesion,
	buscador: string | null | undefined
): Factura[] {
	if (!datos || datos.length === 0) {
		return [];
	}

	let datosFiltrados = [...datos];

	if (filterCesion && filterCesion !== "total") {
		if (filterCesion === "no_cedidas") {
			datosFiltrados = datosFiltrados.filter(item => item.cedido == 0);
		} else if (filterCesion === "cedidas_rc") {
			datosFiltrados = datosFiltrados.filter(item => item.cedido_redcapital == 1);
		} else if (filterCesion === "cedidas_3ros") {
			datosFiltrados = datosFiltrados.filter(item => item.cedido == 1 && item.cedido_redcapital == 0);
		}
	}

	if (buscador !== null && buscador !== undefined && buscador !== "") {
		const search = buscador.toString().toLowerCase();
		datosFiltrados = datosFiltrados.filter(item =>
			item.folio.toString().toLowerCase().includes(search) ||
			(typeof item.deudor_razon_social === "string" && item.deudor_razon_social.toLowerCase().includes(search))
		);
	}

	return datosFiltrados;
}
